/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Studentsozialversicherungspflicht1Inputs */



/**

* @param {_Field_Studentsozialversicherungspflicht1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_studentsozialversicherungspflicht1 = /** @type {((inputs?: _Field_Studentsozialversicherungspflicht1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Studentsozialversicherungspflicht1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sozialversicherungspflicht Student")
});
export { _field_studentsozialversicherungspflicht1 as "_field_studentSozialversicherungspflicht" }